import React from 'react';
import moment from 'moment';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import TableActions from '../../../../shared/table/table-actions';
import Button from '../../../../shared/button';
import Table from '../../../../shared/table';

const tableColumns = ['Purchase Id', 'Invoice Number', 'Created Date', 'Purchase Amount', 'Invoice Amount', 'Discrepacy', 'Actions']

interface IPurchasesTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    onDownloadDetails: (id: string) => void;
    onSeePurchaseDetails: (id: string) => void;
    onEditPurchase: (partnerId: string) => void;
    onSeeMismatchDetails: (id: string) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onDeletePurchase: (id: string) => void;
}

const PurchasesTable = ({
    rows,
    paginationData,
    rowsLoading,
    onDownloadDetails,
    onEditPurchase,
    setPaginationState,
    onDeletePurchase,
    onSeeMismatchDetails,
    onSeePurchaseDetails
}: IPurchasesTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        const totalPurchasePrice = (row?.purchaseInfo?.items && row?.purchaseInfo?.items?.length > 0) && row?.purchaseInfo?.items?.reduce((accumulator: any, currentValue: any) => accumulator + (currentValue?.totalPrice), 0)
                        const findCurrency = row?.currency || row?.purchaseInfo?.currency

                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.quoteId}</td>
                                <td className='px-6 py-4'>{row?.invoiceNumber}</td>
                                <td className='px-6 py-4'>{moment(row?.createdAt).format('DD/MM/YYYY')}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '').toLowerCase()}`]}{Number(row?.analyzedData?.purchaseTotal || totalPurchasePrice || 0).toFixed(2)}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '').toLowerCase()}`]}{Number(row?.analyzedData?.invoiceTotal || row?.invoiceInfo?.total || 0).toFixed(2)}</td>
                                <td className='px-6 py-4'>{CURRENCY_SYMBOLS[`${(findCurrency || '').toLowerCase()}`]}{Number(row?.analyzedData?.discrepancy || 0).toFixed(2)}</td>
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row'>
                                        <div data-qa='purchase-details' onClick={() => (row?._id) && onSeePurchaseDetails(row?.quoteId)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-2'} />
                                        </div>
                                        <TableActions>
                                            <div
                                                onClick={() => onDownloadDetails(row?.quoteId)}
                                                className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                role='none'>
                                                <Button
                                                    label={'Download Details'}
                                                    dataQa={'download-purchase'}
                                                    className={`btn-primary-text-underline !no-underline !font-normal cursor-pointer`}
                                                />
                                            </div>
                                            {row?.status === 'mismatch' &&
                                                <>
                                                    <div
                                                        onClick={() => onSeeMismatchDetails(row?.quoteId)}
                                                        className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                                                        role='none'>
                                                        <Button
                                                            label={'Mismatch Details'}
                                                            dataQa={'mismatch-purchase'}
                                                            className={`btn-primary-text-underline !no-underline !font-normal !text-[#00b67a] cursor-pointer`}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </TableActions>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default PurchasesTable;